export default "__VITE_ASSET__yjwhDK8g__"